import React, { useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import TextInput from '../../../../lib/TextField';
import { ProfileEvent, useProfileInfo } from './profile-context';
import { SubjectiveDetail } from './utils';
import { ALL_HOLDINGS, ZERO_HOLDINGS, NON_ZERO_HOLDINGS } from '../../../../utils/constants';
import { useDispatch } from 'react-redux';
import { getAmcList } from '../../../../redux-store/actions/nct';
import { AMC_LIST_RESPONSE } from '../../../../redux-store/types/nct';
import { isNumber } from '../../../../utils/constants';

export const AdditionalDetails = () => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();
    const [amcDetails, setAmcDetails] = useState<AMC_LIST_RESPONSE[] | null>(null);
    const dispatch = useDispatch();
    useEffect(() => {
        async function callApi() {
            const { body: amcResponse } = await getAmcList()(dispatch);
            amcResponse.sort((first, second) => {
                let amcName1 = first.amc_name.toUpperCase();
                let amcName2 = second.amc_name.toUpperCase();
                if (amcName1 < amcName2) {
                    return -1;
                }
                if (amcName1 > amcName2) {
                    return 1;
                }

                return 0;
            });
            setAmcDetails(amcResponse);
        }
        callApi();
    }, []);
    return (
        <>
            <p className="details-heading"> Additional Details(optional) </p>
            <Grid container spacing={2} className="grid-gap">
                <Grid item xs={12} md={4}>
                    <TextInput
                        value={profileState.folio}
                        variant="filled"
                        className="filled-input-inactive"
                        onChange={(e) => {
                            if (isNumber(e.target.value)) {
                                profileDispatch({
                                    action: ProfileEvent.SetFolio,
                                    payload: e.target.value,
                                });
                            }
                        }}
                        label="Enter your folio no"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    {amcDetails && (
                        <FormControl
                            variant="filled"
                            style={{ border: '1px solid black', borderRadius: '4px' }}
                        >
                            <InputLabel> Select AMC </InputLabel>
                            <Select
                                id="amc-details"
                                value={profileState.amcCode}
                                onChange={(e) => {
                                    profileDispatch({
                                        action: ProfileEvent.SetAmc,
                                        payload: String(e.target.value),
                                    });
                                }}
                            >
                                {amcDetails.map((amcDetail) => {
                                    return (
                                        <MenuItem
                                            key={amcDetail.amc_code}
                                            value={amcDetail.amc_code}
                                        >
                                            {amcDetail.amc_name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    )}
                </Grid>
            </Grid>
        </>
    );
};
